/**
 * Panel.jsx
 *
 * Angular, clipped-corner glass panel used across the redesigned site —
 * replaces the old rounded CRT ScreenFrame. Optionally renders a thin
 * "console header" bar with a status light + label, like a HUD module.
 *
 * Props:
 *   children  {ReactNode}
 *   title     {string}     Optional header label (module readout style)
 *   className {string}
 *   bodyClassName {string}
 *   noPadding {boolean}    Skip the default body padding
 */
import React from 'react';
import GlowText from './GlowText';

export default function Panel({
  children,
  title,
  className = '',
  bodyClassName = '',
  noPadding = false,
}) {
  return (
    <div className={`mech-panel mech-corners ${className}`}>
      {title && (
        <div className="mech-panel-header">
          <span className="status-dot" />
          <GlowText text={title} size={12} variant="cyan" />
        </div>
      )}
      <div className={noPadding ? bodyClassName : `p-5 md:p-8 ${bodyClassName}`}>
        {children}
      </div>
    </div>
  );
}
